import React from 'react'

import PageHeader from '../components/StaticPageHeader'

import Code from '../assets/coding.jpg' 


const DeveloperHeader = () => <PageHeader
    text="Interested in helping develop Succotash to support independent famers and other growers? Find us on Github!"
    image={Code}
/>

export default DeveloperHeader